import { useRef, useEffect } from "react"
import {
  useFloating,
  FloatingOverlay,
  FloatingFocusManager,
  autoUpdate,
  useInteractions,
  useRole,
  useClick,
  useDismiss,
} from "@floating-ui/react"
import { classes, belowViewPort } from "utils"

export const SlidePanel = ({
  className,
  children,
  contentStyle,
  onClose,
  referenceClassName,
  preventHideOnOutsidePress = false,
}) => {
  const {
    refs,
    floatingStyles,
    context: floatingContext,
  } = useFloating({
    open: true,
    placement: "left-start",
    whileElementsMounted: autoUpdate,
    onOpenChange(isOpen) {
      if (!isOpen) onClose()
    },
  })

  const { getFloatingProps } = useInteractions([
    useClick(floatingContext),
    useRole(floatingContext),
    useDismiss(floatingContext, {
      outsidePress: !preventHideOnOutsidePress,
      outsidePressEvent: "mousedown",
      referencePressEvent: "mousedown",
      referencePress: true,
      bubbles: true,
      capture: true,
      enabled: true,
    }),
  ])

  // Use ref to hold the app-content element
  const appContentElement = useRef(null)

  useEffect(() => {
    appContentElement.current = document.querySelector(
      `.${referenceClassName ?? "hamburger-icon"}`,
    )
    if (appContentElement.current) {
      refs.setReference(appContentElement.current) // Pass the actual DOM element
    }
  }, [referenceClassName, refs]) // Ensure refs is included as a dependency

  return (
    <FloatingOverlay
      style={{
        position: "absolute",
        background: "#00000029",
        width: "100%",
        cursor: "pointer",
        zIndex:100
      }}
      className={classes("slide-panel", className)}
    >
      <FloatingFocusManager context={floatingContext} modal={true}>
        <div
          className="floating-content"
          css={[
            floatingStyles,
            {
              minWidth: 0,
              transform: "none",
              transition: "transform 225ms cubic-bezier(0, 0, 0.2, 1)",
              position: "absolute", // Ensure it stays fixed relative to the viewport
              background: "white",
              boxShadow: "-3px 0px 6px #00000029",
            },
            contentStyle,
            belowViewPort(768, { minWidth: "100%" }),
          ]}
          ref={refs.setFloating}
          {...getFloatingProps()}
        >
          {children}
        </div>
      </FloatingFocusManager>
    </FloatingOverlay>
  )
}
